
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/purchase-subscriptions",
      function () {
        return require("private-next-pages/purchase-subscriptions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/purchase-subscriptions"])
      });
    }
  